import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EspaceService } from '@app/features/editeur/services/espace.service';

import { TreeViewService } from '@app/features/editeur/services/tree-view.service';
import { EspaceChipComponent } from '../base-form/espace-chip/espace-chip.component';

/**
 * Etiquette du header affichant l'espace actuellement sélectionné
 */
@Component({
    selector: 'app-espace-indicator',
    imports: [CommonModule, MatIconModule, MatCardModule, MatTooltipModule, EspaceChipComponent],
    templateUrl: './espace-indicator.component.html',
    styleUrls: ['./espace-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EspaceIndicatorComponent {
    private espaceService = inject(EspaceService);
    private treeview = inject(TreeViewService);

    readonly selectedEspace$ = this.espaceService.espaceSelected$;
    readonly racine$ = this.treeview.racineMaquette$.asObservable();
}
